"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = require("react");
function useFetchingPagination(rawItems, options = {}) {
    // Check for the first item reference to allow re-fetch update the items
    const items = (0, react_1.useMemo)(() => rawItems || [], 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [rawItems === null || rawItems === void 0 ? void 0 : rawItems.length, rawItems[0], options.total]);
    const { page: current = 0, perPage = 3, total, fetchMore, enable = !!total, } = options;
    if (enable && !total) {
        if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.error(`Fetching pagination does not work without total items count.`);
        }
    }
    const fetchMoreRef = (0, react_1.useRef)(fetchMore);
    fetchMoreRef.current = fetchMore;
    const [page, setPage] = (0, react_1.useState)(current);
    (0, react_1.useEffect)(function resetStateOnZeroingPage() {
        // current page and incoming page difference is more than 1
        // it occurs only on refetching
        if (current === 0 && items.length - perPage < 1) {
            setPage(current);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [current]);
    return (0, react_1.useMemo)(() => {
        if (!enable) {
            return {
                items,
                page: 0,
                hasMore: false,
                nextPage: noop_1.default,
                prevPage: noop_1.default,
                refreshCurrentPage: noop_1.default,
            };
        }
        const maxPage = Math.ceil(total / perPage) - 1;
        const renderCount = (page + 1) * perPage;
        return {
            items: page < current ? items.slice(0, renderCount) : items,
            page: page,
            hasMore: page < maxPage,
            nextPage() {
                var _a;
                if (page === current) {
                    (_a = fetchMoreRef.current) === null || _a === void 0 ? void 0 : _a.call(fetchMoreRef);
                }
                setPage(prev => (prev <= current ? prev + 1 : prev));
            },
            prevPage() {
                setPage(prev => (prev <= 0 ? 0 : prev - 1));
            },
            refreshCurrentPage: setPage,
        };
    }, [enable, items, current, page, perPage, total]);
}
exports.default = useFetchingPagination;
//# sourceMappingURL=useFetchingPagination.js.map